<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { scale } from "svelte/transition";
  import * as PHE from "print-html-element";
  import config from "../../../stores/config";
  import axios from "axios";
  import * as ls from "local-storage";

  let authData = { headers: { authorization: ls.get("jwt") } };

  // Util function --------------------------------

  let TABLE;
  let totalAdults = 0;
  let totalKids = 0;

  const inferSize = (style) => {
    let { qtyOrdered, fStyleID } = style;

    let size = $config?.fstyles?.find(({ value }) => value == fStyleID)?.size;
    size = size?.toUpperCase().trim();

    // Adult
    if (/^2XS$|^30(a)$|^XXS$/.test(size)) size = "2XS";
    if (/^XS$|^32(a)$|^XS(A)$/.test(size)) size = "XS";
    if (/^S$|^34$|^SMALL$|^SM$/.test(size)) size = "S";
    if (/^M$|^36$|^MEDIUM$|^MED$/.test(size)) size = "M";
    if (/^L$|^38$|^LARGE$|^LG$/.test(size)) size = "L";
    if (/^XL$|^40$|^EXTRALARGE$|^EXTRA-LARGE$/.test(size)) size = "XL";
    if (/^2XL$|^42$|^XXL$/.test(size)) size = "2XL";
    if (/^3XL$|^44$|^XXXL$/.test(size)) size = "3XL";
    if (/^4XL$|^46$|^XXXXL$/.test(size)) size = "4XL";
    if (/^5XL$|^48$|^XXXXXL$/.test(size)) size = "5XL";
    if (/^6XL$|^50$|^XXXXXXL$/.test(size)) size = "6XL";
    // Kiddies
    if (/^20$|^4-5YRS$|^4-5$/.test(size)) size = "20";
    if (/^22$|^5-6YRS$|^5-6$/.test(size)) size = "22";
    if (/^24$|^6-7YRS$|^6-7$/.test(size)) size = "24";
    if (/^26$|^7-8YRS$|^7-8$/.test(size)) size = "26";
    if (/^28$|^9-10YRS$|^9-10$/.test(size)) size = "28";
    if (/^30$|^11-12YRS$|^11-12$/.test(size)) size = "30";
    if (/^32$|^13-14YRS$|^13-14$/.test(size)) size = "32";
    if (/^34$|^4-5YRS$|^XS(K)$/.test(size)) size = "34";

    // later
    let isKiddy = false;
    let isAdult = false;

    if (/^2XS$|^XS$|^S$|^M$|^L$|^XL$|^2XL$|^3XL$|^4XL$|^5XL$|^6XL$/.test(size))
      isAdult = true;
    if (/^20$|^22$|^24$|^26$|^28$|^30$|^32$|^34$/.test(size)) isKiddy = true;

    return {
      size,
      isKiddy,
      isAdult,
      qtyOrdered,
    };
  };

  const getTable = () => {
    let emptyState = {
      size: "",
      isKiddy: "",
      isAdult: "",
      qtyOrdered: "",
    };

    let table = {
      "2XS": emptyState,
      XS: emptyState,
      S: emptyState,
      M: emptyState,
      L: emptyState,
      XL: emptyState,
      "2XL": emptyState,
      "3XL": emptyState,
      "4XL": emptyState,
      "5XL": emptyState,
      "6XL": emptyState,
      "20": emptyState,
      "22": emptyState,
      "24": emptyState,
      "26": emptyState,
      "28": emptyState,
      "30": emptyState,
      "32": emptyState,
      "34": emptyState,
    };

    items?.forEach((item) => {
      table[inferSize(item).size] = inferSize(item);
    });

    return table;
  };

  // -------------------------
  export let show = false;
  // -------------------------
  export let orderID;
  export let earliestDelivery;
  export let items = [];

  let { fStyleID } = items[0] || "";
  let { cutSheetN } = items[0] || "";
  let { cmtID } = items[0] || "";

  let cmtName = $config?.cmts?.find(({ value }) => value == cmtID)?.label;

  // CUSTOMER -------------------------
  export let customerID;
  let title = null;
  let fullName = null;
  let customerType = null; // ["business", "individual"]
  let companyName = null;
  let email = null;
  let tel = null;
  let secondTel = null;
  let website = null;
  let billingAddress = null;
  let shippingAddress = null;

  // FSTYLE --------------------------
  let name = null;
  let price = null;
  let inventoryLevel = null;
  let size = null;
  let SKU = null;
  let description = null;
  let patternID = null;
  let patternPieces = null;
  let costingN = null;
  let contrast = null;
  let embroidery = false;
  let print = false;
  let sublimation = false;

  const handlePrint = () => {
    PHE.printElement(document.getElementById("invoice-area"));
  };

  const dispatch = createEventDispatcher();

  let RECIPE = [];

  onMount(() => {
    // ------------------------------------

    items.forEach((item) => {
      let recipeItem = [];

      let { materialReq } = item;

      let getItem = (itemID) => {
        let name = $config?.items?.find(({ value }) => value == itemID)?.label;

        let stockType = $config?.items?.find(
          ({ value }) => value == itemID
        )?.stockType;

        return {
          name,
          stockType,
        };
      };

      materialReq?.forEach((mat) => {
        recipeItem.push(
          `${mat.qtyReq}x ${getItem(mat?.itemID).name} (${
            getItem(mat?.itemID).stockType
          })`
        );
      });

      RECIPE.push({ key: inferSize(item).size, value: recipeItem });
    });

    // ------------------------------------

    TABLE = getTable();

    for (const key in TABLE) {
      let el = TABLE[key];
      if (el.isKiddy) totalKids += el.qtyOrdered;
      if (el.isAdult) totalAdults += el.qtyOrdered;
    }

    axios.get(`${$config.backendURL}/customers/${customerID}`).then((res) => {
      title = res.data.title;
      fullName = res.data.fullName;
      customerType = res.data.customerType;
      companyName = res.data.companyName;
      email = res.data.email;
      tel = res.data.tel;
      secondTel = res.data.secondTel;
      website = res.data.website;
      billingAddress = res.data.billingAddress;
      shippingAddress = res.data.shippingAddress;
    });

    axios.get(`${$config.backendURL}/fstyles/${fStyleID}`).then((res) => {
      name = res.data.name;
      price = res.data.price;
      inventoryLevel = res.data.inventoryLevel;
      size = res.data.size;
      SKU = res.data.SKU;
      description = res.data.description;
      patternID = res.data.patternID;
      patternPieces = res.data.patternPieces;
      costingN = res.data.costingN;
      contrast = res.data.contrast;

      embroidery = res.data.embroidery;
      print = res.data.print;
      sublimation = res.data.sublimation;
    });
  });

  let PRICES = items.map((itm) => ({
    uPrice: itm.uPrice,
    size: $config?.fstyles?.find(({ value }) => value == itm.fStyleID)?.size,
  }));

  // console.log(PRICES);

  export let orderMongoID;
  export let addInfo = "Type here...";

  $: {
    // console.log(addInfo);

    axios
      .put(
        `${$config.backendURL}/orders/${orderMongoID}`,
        { addInfo: addInfo },
        authData
      )
      .then((res) => {})
      .catch((err) => console.log(err));
  }
</script>

{#if show}
  <!-- content here -->
  <div
    transition:scale
    class="px-6 py-1 fixed top-0 left-0 bottom-0 right-0 flex items-center justify-center overflow-y-auto"
    style="z-index: 1500;  background-color: rgba(0, 0, 0, .75)"
    on:click|self={() => dispatch("close")}
  >
    <div
      class="py-1 px-8 absolute top-0 left-0 right-0 flex items-center justify-center"
    >
      <button
        class="btn btn-red"
        style="padding: .5rem 4rem !important; font-size: .85rem;"
        on:click={handlePrint}
      >
        <i class="fas fa-print mr-2 text-base" />
        PRINT CUT SHEET NUMBER
      </button>
      <button
        class="btn btn-secondary ml-8"
        style="padding: .5rem 4rem !important; font-size: .85rem;"
        on:click={() => dispatch("close")}
      >
        <i class="fas fa-times-circle mr-2 text-base" />
        CLOSE
      </button>
    </div>

    <div class="A4-parent bg-white">
      <div
        class="A4 py-6 px-10 text-xs overflow-auto bg-white"
        id="invoice-area"
      >
        <!--  -->
        <div class="grid grid-cols-5 gap-4">
          <img src="./favicon-rect.png" class="h-8" alt="" />
          <div>
            <div>Tel: 02 852 7502</div>
            <div>Fax: 086 691 0372</div>
          </div>
          <div>
            <div>10 Stuart Close</div>
            <div>Somerset Business Park</div>
            <div>Somerset West</div>
          </div>
          <div>
            <div>P.O.Box 2033</div>
            <div>Somerset West, 7129</div>
          </div>
          <div>
            <div>CUT SHEET #:</div>
            <div class="bungee text-lg font-thin">{cutSheetN}</div>
            <div>ORDER NUMBER:</div>
            <div class="bungee text-lg font-thin">#{orderID}</div>
          </div>
        </div>
        <!--  -->
        <div class="my-2 grid grid-cols-6">
          <div class="col-span-5">
            REG. NO.: CK 1988-13094-23 VAT NO.: 4810205460
          </div>
          <div class="italic">Date: {new Date().toDateString()}</div>
        </div>
        <!--  -->
        <!--  -->
        <!-- Row 1 -->
        <div class="lines mt-2 grid grid-cols-12">
          <div>Customer:</div>
          <div class="col-span-2 italic">{companyName}</div>
          <div>Contact:</div>
          <div class="col-span-2 italic">{fullName}</div>
          <div>Tel:</div>
          <div class="col-span-2 italic">{tel}</div>
          <div>Cell:</div>
          <div class="col-span-2 italic">{secondTel}</div>
        </div>

        <!-- Row 2 -->
        <div class="lines grid grid-cols-12">
          <div>Customer Ref:</div>
          <div class="col-span-2 italic">
            {orderID}
          </div>
          <div>Pattern ID:</div>
          <div class="col-span-2 italic">{patternID}</div>
          <div>Pattern Pieces:</div>
          <div class="col-span-2 italic">{patternPieces}</div>
          <div>CMT Plant:</div>
          <div class="col-span-2 italic">{cmtName?.split("(")[0]}</div>
        </div>

        <!-- Row 3:1 -->
        <div class="lines grid grid-cols-12">
          <div>Cost:</div>
          <div class="col-span-11 italic text-white">
            .
            <!-- {#each PRICES as price}
              <span class="mr-2 rounded-lg px-2 bg-gray-100 text-black">
                {price.size}—R{price.uPrice}
              </span>
            {/each} -->
          </div>
          <!-- <div>Item Code:</div>
          <div class="col-span-5 italic">{costingN}</div> -->
        </div>

        <!-- Row 3:2 -->
        <div class="lines grid grid-cols-12">
          <!-- <div>Cost:</div>
          <div class="col-span-5 italic">
            {#each PRICES as price}
              <span class="mr-2 rounded-lg px-2 bg-gray-100 text-black">
                {price.size}—R{price.uPrice}
              </span>
            {/each}
          </div> -->
          <div>Item Code:</div>
          <div class="col-span-5 italic">{costingN}</div>
          <div>Delivery Date :</div>
          <div class="col-span-5 italic">
            {new Date(earliestDelivery).toDateString() || "N/A"}
          </div>
        </div>

        <!-- Row 4 -->
        <div class="lines grid grid-cols-12">
          <div>Style:</div>
          <div class="col-span-5 italic">
            {name}
          </div>
          <div>Instructions:</div>
          <div class="col-span-5" />
        </div>

        <!-- Forgotten Row -->
        <div class="lines grid grid-cols-12">
          <div>Sample:</div>
          <div class="col-span-5" />
          <div>CAD/Sketch:</div>
          <div class="col-span-5" />
        </div>

        <!-- Row 4 -->
        <div class="lines">
          <div>Material</div>
        </div>
        <!-- <div class="lines grid grid-cols-12">
          <div>Basis:</div>
          <div class="col-span-5" />
          <div>Lining:</div>
          <div class="col-span-5" />
        </div> -->

        <!-- Material Requirements -->
        <!-- <div class="lines"> -->
        <div
          class="block border-l border-r border-black pt-1 px-2"
          style="margin-left: -1px;"
        >
          {#each RECIPE as REC}
            {#if REC?.value?.length > 0}
              <span class="text-black">
                {REC.key} :
                {#each REC?.value as val}
                  <span class="rounded-lg px-2 bg-gray-100 mx-1">
                    {val}
                  </span>
                {/each}
              </span>
              <div class="pb-1" />
            {/if}
          {/each}
        </div>
        <!-- </div> -->

        <!-- Row 5 -->
        <div class="lines">
          <div>Contrast: {contrast || ""}</div>
        </div>
        <div class="lines grid grid-cols-12">
          <div>1.</div>
          <div class="col-span-5" />
          <div>2.</div>
          <div class="col-span-5" />
        </div>

        <!-- Row 6 -->
        <div class="lines grid grid-cols-12">
          <div>Timmings:</div>
          <div class="col-span-5" />
          <div>Embroidery:</div>
          <div>
            {#if embroidery}
              ✅
            {:else}
              ❌
            {/if}
          </div>
          <div>Print:</div>
          <div>
            {#if print}
              ✅
            {:else}
              ❌
            {/if}
          </div>
          <div>Sublimation:</div>
          <div>
            {#if sublimation}
              ✅
            {:else}
              ❌
            {/if}
          </div>
        </div>

        <!-- Row 7 -->
        <div class="lines grid grid-cols-12">
          <div class="col-span-2">Markers:</div>
          <div>Length:</div>
          <div>Total Piles:</div>
          <div class="col-span-2">Contrast 1:</div>
          <div>Length:</div>
          <div>Total Piles:</div>
          <div class="col-span-2">Contrast 2:</div>
          <div>Length:</div>
          <div>Total Piles:</div>
        </div>

        <!-- Row 8 -->
        {#each [1, 2, 3, 4, 5, 6] as row8}
          <div class="lines grid grid-cols-12">
            <div class="col-span-2 text-white">.</div>
            <div />
            <div />
            <div class="col-span-2 italic" />
            <div />
            <div />
            <div class="col-span-2 italic" />
            <div />
            <div />
          </div>
        {/each}

        <!-- Row 9 -->
        <div class="lines">
          <div>Sizes:</div>
        </div>
        <div class="lines grid grid-cols-12">
          <div>2XS</div>
          <div>XS</div>
          <div>S</div>
          <div>M</div>
          <div>L</div>
          <div>XL</div>
          <div>2XL</div>
          <div>3XL</div>
          <div>4XL</div>
          <div>5XL</div>
          <div>6XL</div>
          <div>TOTAL</div>
        </div>

        <!-- Row 10 -->
        <div class="lines grid grid-cols-12">
          <div>30(A)</div>
          <div>32(A)</div>
          <div>34</div>
          <div>36</div>
          <div>38</div>
          <div>40</div>
          <div>42</div>
          <div>44</div>
          <div>46</div>
          <div>48</div>
          <div>50</div>
          <div>TOTAL</div>
        </div>

        <!-- Row 11 -->
        <div class="lines">
          <div>Quantity:</div>
        </div>
        <div class="lines grid grid-cols-12">
          <div class="font-semibold">{TABLE["2XS"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["XS"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["S"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["M"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["L"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["XL"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["2XL"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["3XL"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["4XL"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["5XL"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["6XL"].qtyOrdered}</div>
          <div class="font-semibold bg-gray-100">
            {totalAdults}
          </div>
        </div>

        <!--  -->
        <div class="lines">
          <div class="text-white">.</div>
        </div>
        <!--  -->

        <!-- Row 12 -->
        <div class="lines">
          <div>Kiddies:</div>
        </div>
        <div class="lines grid grid-cols-12">
          <div>4-5 YRS</div>
          <div>5-6 YRS</div>
          <div>6-7 YRS</div>
          <div>7-8 YRS</div>
          <div>9-10 YRS</div>
          <div>11-12 YRS</div>
          <div>13-14 YRS</div>
          <div>XS(K)</div>
          <div />
          <div />
          <div />
          <div>TOTAL</div>
        </div>

        <!-- Row 13 -->
        <div class="lines grid grid-cols-12">
          <div>20</div>
          <div>22</div>
          <div>24</div>
          <div>26</div>
          <div>28</div>
          <div>30</div>
          <div>32</div>
          <div>34</div>
          <div />
          <div />
          <div />
          <div>TOTAL</div>
        </div>

        <!-- Row 14 -->
        <div class="lines">
          <div>Quantity:</div>
        </div>
        <div class="lines grid grid-cols-12">
          <div class="font-semibold">{TABLE["20"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["22"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["24"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["26"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["28"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["30"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["32"].qtyOrdered}</div>
          <div class="font-semibold">{TABLE["34"].qtyOrdered}</div>
          <div />
          <div />
          <div />
          <div class="font-semibold bg-gray-100">
            {totalKids}
          </div>
        </div>

        <div class="lines">
          <div class="text-white">.</div>
        </div>

        <div class="grid grid-cols-4">
          <div class="col-span-3">
            <div class="lines uppercase font-semibold">
              <div class="">Additional Info:</div>
            </div>
            <div class="lines" style="height: calc(100% - 21px);">
              <div
                class="a-info h-full w-full"
                contenteditable="true"
                bind:innerHTML={addInfo}
              />
            </div>
            <!-- {#each [1, 2, 3, 4, 5, 6, 7, 8, 9] as aRow}
              <div class="lines grid grid-cols-1">
                <div class="col-span-2 text-white">.</div>
              </div>
            {/each} -->
          </div>
          <div class="">
            <!--  -->
            <div class="lines uppercase font-semibold">
              <div class="">Material:</div>
            </div>
            {#each [1, 2, 3] as dummy}
              <div class="lines grid grid-cols-1">
                <div class="col-span-2 text-white">.</div>
              </div>
            {/each}
            <!--  -->
            <div class="lines uppercase font-semibold">
              <div class="">Lining:</div>
            </div>
            {#each [1, 2] as dummy}
              <div class="lines grid grid-cols-1">
                <div class="col-span-2 text-white">.</div>
              </div>
            {/each}
            <!--  -->
            <div class="lines uppercase font-semibold">
              <div class="">Zips:</div>
            </div>
            {#each [1, 2] as dummy}
              <div class="lines grid grid-cols-1">
                <div class="col-span-2 text-white">.</div>
              </div>
            {/each}
            <!--  -->
          </div>
        </div>

        <!--  -->
        <!--  -->
        <!--  -->
      </div>
    </div>
  </div>
{/if}

<style>
  /* .A4 { */
  /* width: 90vw; */
  /* height: 95vh; */
  /* height: 2480px; */
  /* width: 3508px; */
  /* } */

  .A4-parent {
    width: 297mm;
    height: 95vh;
    overflow: scroll;
  }

  .A4 {
    width: 295mm;
  }

  .lines {
    margin-top: -1px;
  }

  .lines div {
    border: 1px solid rgb(31, 41, 55);
    box-sizing: border-box;
    margin-left: -1px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.15rem 0.05rem;
    text-align: center;
  }

  .a-info {
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center;
    padding: 0.5rem !important;
  }
</style>
